<template>
    <v-container container--fluid fill-height>
        <v-layout flex align-center justify-center>
            <div class="wrapper-login">
                <h1 class="headline">Login</h1>
                <v-list v-if="server_errors !== null && !loading" style="background: rgba(0, 0, 0, 0)">
                    <div v-for="(item, index) in server_errors" :key="index">
                        <v-list-item-content class="error--text">
                            {{ titleCase(item) }}
                        </v-list-item-content>
                    </div>
                    <!-- <div>
                        <v-list-item-content>
                            {{ titleCase(errors) }}
                        </v-list-item-content>
                    </div> -->
                </v-list>
                <v-form v-if="!two_step" @submit.prevent="">
                    <v-text-field
                        id="email"
                        name="email"
                        type="email"
                        label="E-mail*"
                        v-model.trim="authenticate.email"
                        required
                        autofocus
                        placeholder="Please Enter"
                        :error-messages="errors($v.authenticate.email)"
                        @blur="$v.authenticate.email.$touch()"
                        @keydown.enter="login"
                    >
                    </v-text-field>
                    <v-text-field
                        id="password"
                        name="password"
                        label="Password*"
                        v-model.trim="authenticate.password"
                        :append-icon="e1 ? 'visibility' : 'visibility_off'"
                        @click:append="e1 = !e1"
                        :type="e1 ? 'password' : 'text'"
                        placeholder="Please Enter"
                        required
                        :error-messages="errors($v.authenticate.password)"
                        @blur="$v.authenticate.password.$touch()"
                        @keydown.enter="login">
                    </v-text-field>
                    <v-alert class="pa-2 mt-4" :value="$v.authenticate.$error" outlined color="error" icon="priority_high" transition="scale-transition">
                        <span class="caption">Please fill out all fields correctly</span>
                    </v-alert>
                    <v-btn
                        id="btnLogin"
                        block
                        color="primary"
                        :loading="loading"
                        :disabled="loading"
                        @click="login">
                        Login
                    </v-btn>
                    <span id="forgot-password-link" class="text-center">
                        <router-link to="reset_password">Forgot Your Password?</router-link>
                    </span>
                    <span id="register-organization-link" class="text-center">
                        <router-link to="organization_onboarding">Register new organization</router-link>
                    </span>
                </v-form>
                <v-form v-else @submit.prevent="">
                    <div class="mb-4">Send Code from SMS message to complete login</div>
                    <v-text-field
                        class="mb-4"
                        id="login-code"
                        name="code"
                        label="Code*"
                        v-model.trim="authenticateCode.code"
                        required
                        autofocus
                        placeholder="Please Enter"
                        :error-messages="errors($v.authenticateCode.code)"
                        @blur="$v.authenticateCode.code.$touch()"
                        @keydown.enter="loginCode"
                    >
                    </v-text-field>
                    <v-alert class="pa-2 mt-4" :value="$v.authenticateCode.$error" outlined color="error" icon="priority_high" transition="scale-transition">
                        <span class="caption">Please fill out all fields correctly</span>
                    </v-alert>
                    <v-btn
                        id="btnLoginCode"
                        block
                        color="primary"
                        :loading="loading"
                        :disabled="loading"
                        @click="loginCode">
                        Login Code
                    </v-btn>
                </v-form>
            </div>
        </v-layout>
    </v-container>
</template>

<script>
    import { validationMixin } from 'vuelidate'
    import { required, email, helpers } from 'vuelidate/lib/validators'
    import { valMessages, getValMessage } from '@/common/error-messages'
    import {mapState, mapGetters} from "vuex"
    import momentTimeZone from 'moment-timezone'
    import {LOGIN, LOGIN_CODE, CHECK_AUTH} from "@/store/actions.type"

    const validations = {
        authenticate: {
            email: { required, email },
            password: { required }
        },
        authenticateCode: {
            code: { required, odometer: v => !helpers.req(v) || v.length === 4 }
        }
    }
    export default {
        name: 'Login',
        mixins: [validationMixin],
        validations,
        data: () => ({
            errorShow: false,
            authenticate: {
                email: '',
                password: '',
                timezone:''
            },
            loading: false,
            e1: true,
            two_step: false,
            authenticateCode: {},
            token: null
        }),
        beforeMount() {
            this.authenticate.timezone = momentTimeZone.tz.guess();
        },
        methods: {
            login() {
                this.$v.authenticate.$touch()
                if(!this.$v.authenticate.$invalid) {
                    this.loading = true
                    this.$store
                        .dispatch(LOGIN, this.authenticate)
                        .then(response => {
                            if(Number(response.user.two_factor) !== 1) {
                                if(this.firstLogin) {
                                this.$router.push({name: "change_password"}) 
                                } else {
                                    this.$router.push({name: "dashboard"})
                                }
                            } else {
                                this.two_step = true
                                this.token = response.token
                            }
                            this.loading = false
                        })
                        .catch(({ response }) => {
                        this.loading = false
                        })
                }
            },
            loginCode() {
                this.$v.authenticateCode.$touch()
                if(!this.$v.authenticateCode.$invalid) {
                    this.loading = true
                    let body = {...this.authenticateCode}
                    body.token = this.token
                    this.$store
                        .dispatch(LOGIN_CODE, body)
                        .then(response => {
                            let token = this.token
                            this.$store
                                .dispatch(CHECK_AUTH, token)                    
                                .then(response => {
                                    if(this.firstLogin) {
                                        this.$router.push({name: "change_password"}) 
                                    } else {
                                        this.$router.push({name: "dashboard"})
                                    }
                                    this.loading = false
                                })
                                .catch(error => {
                                    console.log(error)
                                    this.loading = false
                                })
                        })
                        .catch(({ response }) => {
                            this.loading = false
                        })
                }
            },
            // Title case
            titleCase(str){
                return _.startCase(str.replace(/_/g, ' '))
            },
            errors: getValMessage(valMessages)(validations)
        },
        computed: {
            ...mapState({
                server_errors: state => state.auth.errors
            }),
            ...mapGetters(["firstLogin"])
        }
    }
</script>

<style>
    .wrapper-login h1 {
        text-align: center;
        padding-bottom: 20px;
    }

    .wrapper-login {
        width: 100%;
        max-width: 300px;
    }

    .wrapper-login #forgot-password-link, .wrapper-login #register-organization-link  {
        display: block;
        margin-top: 15px;
    }

    .btn__content {
        padding-top: 2px;
        height: fit-content;
    }
</style>
